// hooks/useDaysArray.ts
import { useMemo } from "react";
import { differenceInCalendarDays, addDays } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const useDaysArray = (start: string, end: string, timezone: string) => {
  const numDays = useMemo(
    () => differenceInCalendarDays(end, start) + 1,
    [end, start]
  );

  const daysArray = useMemo(
    () => Array.from({ length: numDays }, (_, i) => addDays(start, i)),
    [numDays, start]
  );

  // convert daysArray to string
  const daysArrayString = daysArray.map((date) =>
    formatInTimeZone(date, "UTC", "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
  );

  return { daysArray: daysArrayString, numDays };
};
